import React, { useEffect } from "react";

import { BrowserRouter as Router } from "react-router-dom";
import Navigations from "./components/Navigations/Navigation";
import { GlobalStyles } from "./components/GlobalStyled/GlobalStyled";
import UserState from "./components/context/UserState";
//import "./App.css";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'

function App() {
  //const navigate = useNavigate();  return <div></div>;
  return (
      // <React.StrictMode>
      <Router>
        <UserState>
          <GlobalStyles />
          <Navigations />
        </UserState>
    </Router>
    //  </React.StrictMode>
  )
}

export default App;
